import { useRef, useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'

/*
 * QuestionEssay component. Used for displaying journal entries within a journey
 */
export default function QuestionEssay({
  defaultValue = '',
  question,
  handleSaveResponse
}) {
  const ref = useRef()
  const [isLoading, setIsLoading] = useState(false)

  return (
    question && (
      <Form.Group className='form-group journal-entry'>
        <Form.Control
          className='question-essay'
          as='textarea'
          placeholder='Start journaling here...'
          rows={6}
          defaultValue={defaultValue}
          ref={ref}
        />
        <Button
          className='w-100 mt-3'
          type='primary'
          disabled={isLoading}
          onClick={async e => {
            // Prevent the form from submitting
            e.preventDefault()
            e.stopPropagation()
            setIsLoading(true)

            // Save the response
            const saved = await handleSaveResponse(ref.current.value)
            if (saved) setIsLoading(false)
          }}
        >
          {isLoading ? (
            <>
              <Spinner
                animation='border'
                role='status'
                className='inline-spinner mx-2'
                variant='light'
                size='sm'
              />
              Saving...
            </>
          ) : (
            'Save'
          )}
        </Button>
      </Form.Group>
    )
  )
}
